import { getIcon } from './utils/getIcon';
export const getSocialLinks = (themeName) => [
    {
        label: 'Telegram',
        href: 'https://t.me/AlphaFiSUI',
        icon: themeName === 'dark' ? getIcon('whiteTelegramIcon') : getIcon('darkThemeTelegram'),
    },
    {
        label: 'Discord',
        href: 'http://discord.gg/Pn6cKUSqSs',
        icon: themeName === 'dark' ? getIcon('discordWhite') : getIcon('discordFooter'),
    },
    {
        label: 'Twitter',
        href: 'https://x.com/AlphaFiSUI',
        icon: themeName === 'dark' ? getIcon('whiteTwitter') : getIcon('darkThemeTwitter'),
    },
    {
        label: 'Medium',
        href: 'https://alphafisui.medium.com/',
        icon: themeName === 'dark' ? getIcon('WhiteMediumIcon') : getIcon('darkThemeMedium'),
    },
];
export const AUDIT_LINKS = [
    {
        label: 'Audited by Movebit',
        href: 'https://movebit.xyz/reports/20241214-AlphaFi-Smart-Contarct-Final-Audit-Report.pdf',
    },
];
export const DOCS_LINKS = [
    { label: 'Analytics', href: '/analytics' },
    { label: 'Docs', href: 'https://docs.alphafi.xyz/' },
];
export const getFooterLinks = (themeName) => ({
    auditLinks: AUDIT_LINKS,
    docsLinks: DOCS_LINKS,
    socialLinks: getSocialLinks(themeName),
});
export const getNavLinks = (themeName) => [
    {
        name: 'Lend',
        href: '/',
    },
    {
        name: 'Strategies',
        href: '/strategies',
    },
    {
        name: 'Portfolio',
        href: '/portfolio',
        badge: 'Beta',
    },
    {
        name: 'ALPHA',
        href: '/alpha',
    },
    {
        name: 'Security',
        href: '/security',
        isExternal: false,
    },
    {
        name: 'More',
        href: '',
        icon: themeName === 'dark' ? getIcon('darkThemeDownArrow') : getIcon('downArrowBlack'),
        subLinks: [
            {
                name: 'stSUI',
                href: '/stsui',
                isExternal: false,
            },
            {
                name: 'Analytics',
                href: '/analytics',
                isExternal: false,
            },
            {
                name: 'Vote',
                href: '/vote',
                isExternal: false,
            },
            {
                name: 'Transfer Receipt',
                href: '/transfer-receipt',
                isExternal: false,
            },
            {
                name: 'Cetus compensation',
                href: '/cetus-compensation',
                isExternal: false,
            },
        ],
    },
];
// For backward compatibility, export the default dark theme version
export const NAV_LINKS = getNavLinks('dark');
export const getHeaderBackgroundClass = (pathname) => {
    return pathname === '/' || pathname.includes('/market/') || pathname.includes('/portfolio')
        ? 'theme-bg-lndBody'
        : pathname === '/alpha-page'
            ? 'theme-bg-vote-page'
            : 'theme-bg-alphafi-main-body';
};
